export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100/80 to-background-50 z-0"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-20 z-0">
        <div className="absolute inset-0 bg-gradient-to-l from-primary-500/30 via-accent-500/20 to-transparent"></div>
        <div className="absolute top-[10%] right-[5%] w-[500px] h-[500px] rounded-full bg-primary-500/10 blur-3xl"></div>
        <div className="absolute bottom-[10%] right-[20%] w-[400px] h-[400px] rounded-full bg-accent-500/10 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-accent-100/10 text-accent-300 border border-accent-300/20 whitespace-nowrap">
                <i className="ri-fire-line mr-1"></i>独家内容
              </span>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-primary-100/10 text-primary-400 border border-primary-400/20 whitespace-nowrap">
                <i className="ri-vip-crown-line mr-1"></i>VIP免费看
              </span>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-secondary-100/10 text-secondary-300 border border-secondary-300/20 whitespace-nowrap">
                <i className="ri-timer-flash-line mr-1"></i>每日更新
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-50 leading-tight mb-4">
              日皮视频{' '}
              <span className="text-primary-500">—</span>{' '}
              <span className="text-foreground-200">
                蜜桃视频与红桃视频独家专题平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-medium mb-6 font-heading">
              香蕉视频樱花视频VIP会员免费看，排行榜精选你感兴趣的好视频
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[640px] mx-auto lg:mx-0 mb-8">
              日皮视频是专注精品视频内容聚合的在线观影平台，深度整合蜜桃视频与红桃视频独家推荐资源，同步覆盖香蕉视频、樱花视频等热门频道的VIP免费内容。
              每日更新特色专题与热门排行榜，通过精细化内容筛选，为用户提供高清流畅不缓冲的优质观影体验。
              当前平台已覆盖多个主流视频品牌频道，无论是独家推荐还是热门排行，都能在这里一站直达。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">5000+</div>
                <div className="text-xs text-foreground-600 mt-1">精选片源</div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-foreground-600 mt-1">持续上新</div>
              </div>
              <div className="w-px h-10 bg-background-300/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-300 font-heading">高清流畅</div>
                <div className="text-xs text-foreground-600 mt-1">不缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即探索精选
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-200/80 hover:bg-background-300/80 text-foreground-200 font-medium text-sm rounded-lg border border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line text-lg"></i>
                查看排行榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden bg-background-100 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20composition%20with%20warm%20amber%20and%20gold%20highlights%2C%20stylized%20geometric%20flowing%20shapes%20suggesting%20premium%20video%20content%20curation%20and%20streaming%20entertainment%2C%20deep%20charcoal%20background%20with%20rich%20warm%20golden%20accents%2C%20elegant%20modern%20digital%20art%20style%2C%20sophisticated%20atmosphere%2C%20high%20contrast%20between%20darkness%20and%20luminous%20elements%2C%20flowing%20organic%20curves%20representing%20motion%20and%20dynamic%20energy&width=960&height=720&seq=hero-visual-2026-rv01&orientation=landscape"
                alt="日皮视频 - 精品视频内容聚合平台主视觉"
                className="w-full h-full object-cover"
                title="日皮视频 - 蜜桃视频与红桃视频独家专题"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500/90 text-background-950 whitespace-nowrap">
                    <i className="ri-star-fill mr-1 text-[10px]"></i>热门推荐
                  </span>
                  <span className="text-xs text-foreground-300">蜜桃视频 · 红桃视频 联合专题</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}